import {
  buildConsentRouteState,
  buildForm21RouteState,
  buildForm22RouteState,
} from './applicationDraft';

export const APPLICATION_FLOW_STEP = Object.freeze({
  FORM1: 'form1',
  FORM21: 'form21',
  FORM22: 'form22',
  CONFIRM: 'confirm',
});

export const getApplicationFlowHistoryIndex = () => {
  const historyIndex = window.history?.state?.idx;

  return Number.isInteger(historyIndex) ? historyIndex : null;
};

export const canMoveApplicationFlowHistoryBack = () => {
  const historyIndex = getApplicationFlowHistoryIndex();

  return Number.isInteger(historyIndex) && historyIndex > 0;
};

export const isApplicationFlowBackPopState = (event, previousHistoryIndex) => {
  const nextHistoryIndex = event?.state?.idx;

  return Number.isInteger(previousHistoryIndex) && Number.isInteger(nextHistoryIndex) && nextHistoryIndex < previousHistoryIndex;
};

const buildExtraRouteState = (lendelaData) => {
  if (!lendelaData) {
    return {};
  }

  return {
    lendela_data: lendelaData,
  };
};

export const buildApplicationFlowPreviousRoute = ({ step, flowMeta, draft, pageState, lendelaData, routes = {} } = {}) => {
  const flowRoutes = {
    consent: '/application-consent',
    form: '/application-form-1',
    form21: '/application-form-2-1',
    form22: '/application-form-2-2',
    ...routes,
  };

  switch (step) {
    case APPLICATION_FLOW_STEP.FORM1: {
      const state = buildConsentRouteState(flowMeta ?? draft?.meta);

      return state ? { pathname: flowRoutes.consent, state } : null;
    }

    case APPLICATION_FLOW_STEP.FORM21: {
      const state = buildConsentRouteState(flowMeta ?? draft?.meta);

      return state ? { pathname: flowRoutes.form, state } : null;
    }

    case APPLICATION_FLOW_STEP.FORM22: {
      const state = buildForm21RouteState(
        {
          form1: draft?.form1 ?? pageState?.form1,
        },
        buildExtraRouteState(lendelaData),
      );

      return state ? { pathname: flowRoutes.form21, state } : null;
    }

    case APPLICATION_FLOW_STEP.CONFIRM: {
      const state = buildForm22RouteState(
        {
          form1: draft?.form1 ?? pageState?.form1,
          form21: draft?.form21 ?? pageState?.form2,
        },
        buildExtraRouteState(lendelaData),
      );

      return state ? { pathname: flowRoutes.form22, state } : null;
    }

    default:
      return null;
  }
};
